import React, {Component} from 'react';
import { Row, Col, Container} from 'react-bootstrap';
import ContactBlock from '../components/contact-block';

class ContactUs extends Component {
  render() {
    return(
      <Container className="le-contact-page">
        <div className="header">
          <h1>Get In Touch</h1>
          <p>HOME . CONTACTS</p>
        </div>
        <ContactBlock />
      </Container>
    )
  }
}

export default ContactUs;